export default __webpack_public_path__ + "static/media/EnergyDistribution_icon.880dce66.svg";